import React, {useEffect, useMemo} from "react";
import {Modal, Table} from "react-bootstrap";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {ModalProgressBar} from "../../../../_metronic/_partials/controls";
import * as formatter from "../../../../utils/formatter";
import * as actions from "../../../../redux/modules/orders/actions";
import {ORDER_STATUS, PAYMENT_METHOD} from "../../../../utils/codes";
import {OrderProductsTable} from "../OrderProductsTable";

export function OrderDetailModal({show, onHide, orderId}) {
  // Products Redux state
  const dispatch = useDispatch();
  const {isLoading, order} = useSelector(
    (state) => ({
      isLoading: state.orders.actionsLoading,
      order: state.orders.order,
    }),
    shallowEqual
  );

  const format = useMemo(() => ({
    DotFormatter: formatter.dot(ORDER_STATUS),
    DateFormatter: formatter.dateTime,
    PriceFormatter: formatter.price,
    PaymentMethodFormatter: formatter.label(PAYMENT_METHOD),
  }), []);

  useEffect(() => {}, [isLoading, dispatch]);

  useEffect(() => {
    if (orderId) {
      dispatch(actions.fetchOrder(orderId));
    }
  }, [orderId, dispatch]);

  if (!order) return null;

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        size="xl"
        aria-labelledby="example-modal-sizes-title-lg"
        centered
      >
        {isLoading && <ModalProgressBar/>}
        <Modal.Header>
          <div>
            <h3>주문 상세</h3>
            <span className="text-dark-50">주문 상세 정보를 확인하세요.</span>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Table responsive borderless>
            <colgroup>
              <col width="20%"/>
              <col width="30%"/>
              <col width="20%"/>
              <col width="30%"/>
            </colgroup>
            <tbody>
            <tr>
              <th>주문 상태</th>
              <td>{format.DotFormatter(order.ordSttsCd)}</td>
              <th>주문 일시</th>
              <td>{format.DateFormatter(order.ordDtime)}</td>
            </tr>
            <tr>
              <th>주문번호</th>
              <td>{order.ordNo}</td>
              <th>상품 코드</th>
              <td>{order.goodsNo}</td>
            </tr>
            </tbody>
          </Table>

          <p className="font-weight-boldest text-primary mt-6 mb-2">주문 상품 정보</p>
          <OrderProductsTable products={order.orderGoodsList} />

          <p className="font-weight-boldest text-primary mt-6 mb-2">결제/배송 정보</p>
          <Table bordered>
            <colgroup>
              <col width="20%"/>
              <col width="30%"/>
              <col width="20%"/>
              <col width="30%"/>
            </colgroup>
            <tbody>
            <tr>
              <th>결제금액</th>
              <td>{format.PriceFormatter(order.payAmt)}</td>
              <th>배송비</th>
              <td>{format.PriceFormatter(order.delvAmt)}</td>
            </tr>
            <tr>
              <th>결제수단</th>
              <td>{order.payMthdCdnm}</td>
              <th>택배사</th>
              <td>{order.delvAgncCdnm || '-'}</td>
            </tr>
            </tbody>
          </Table>

          <p className="font-weight-boldest text-primary mb-5">주문자/배송지 정보</p>
          <Table bordered className="mb-0">
            <colgroup>
              <col width="20%"/>
              <col width="30%"/>
              <col width="20%"/>
              <col width="30%"/>
            </colgroup>
            <tbody>
            <tr>
              <th>주문자</th>
              <td>{order.ordUserNm}</td>
              <th>연락처</th>
              <td>{order.ordUserTelNo}</td>
            </tr>
            <tr>
              <th>수령인</th>
              <td>{order.delvUserNm}</td>
              <th>수령인 연락처</th>
              <td>{order.delvUserTelNo}</td>
            </tr>
            <tr>
              <th>배송지</th>
              <td colSpan={3}>
                ({order.delvZipCode}) {" "}
                {order.delvAddr} {" "}
                {order.delvDtlAddr}
              </td>
            </tr>
            <tr>
              <th>배송메모</th>
              <td colSpan={3}>
                {order.delvReqContsCd === '04' ? order.delvReqEtcConts : order.delvReqContsCdnm}
              </td>
            </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button type="button" className="btn btn-dark btn-elevate w-130px" onClick={onHide}>
              확인
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
